import React from "react";
import axios from "axios";
import Dialog from "rc-dialog";
import { browserHistory } from "react-router";

import { getDeep } from "../components/Utils";

import "rc-dialog/assets/bootstrap.css";

class SendResultsModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      allStudentsPresent: false,
      dialogConfirmationVisible: false,
      showAlertNoStudents: false,
      showAlertNoCheckbox: false,
      sendMeasurementsInfo: "",
      sendMeasurementsAlert: "",
      instructorsPresent: [localStorage.userUUID],
      checkbox1: false,
      courseExemptions: []
    };
  }

  handleInstructorPresentChange = (e) => {
    let instructorsPresent = this.state.instructorsPresent;
    if (instructorsPresent.includes(e.target.value)) {
      instructorsPresent = instructorsPresent.filter((present) => present !== e.target.value);
    } else {
      instructorsPresent.push(e.target.value);
    }
    this.setState({
      instructorsPresent
    });
  };

  handleAlertClose = () => {
    this.setState({
      showAlertNoStudents: false,
      showAlertNoCheckbox: false,
      sendMeasurementsAlert: "",
      sendMeasurementsInfo: ""
    });
  };

  handleDialogClose = () => {
    this.props.closeDialog();
  };

  handleCheckbox = (elem) => {
    this.setState(
      {
        [elem]: !this.state[elem],
        showAlertNoCheckbox: true
      },
      () => {
        this.handleAlertClose();
      }
    );
  };

  checkStudentsPresent = () => {
    // Check if all the students are present
    let studentsPresent = 0;
    let currentEvent = this.props.events[this.props.params.eventId];

    if (currentEvent !== undefined) {
      if (currentEvent.event_roles !== undefined) {
        currentEvent.event_roles.forEach((eventRole) => {
          eventRole.students
            .filter((s) => !s.cancelled)
            .forEach((student) => {
              if (student.will_attend) {
                studentsPresent++;
              }
            });
        });

        let allStudentsPresent = false;
        if (this.props.students[this.props.params.eventId] !== undefined) {
          allStudentsPresent = studentsPresent === this.props.students[this.props.params.eventId].length;
        }

        this.setState({
          allStudentsPresent
        });

        if (getDeep(this.props.students, [this.props.params.eventId]) && this.state.showAlertNoStudents) {
          this.setState({
            showAlertNoStudents: false
          });
        }
      }
    }
  };

  handleSaveEvent = () => {
    if (this.refs.checkbox1.checked) {
      // Both checked, allow saving the event
      let sendMeasurements = [];

      let eventDetails = getDeep(this.props.measurements, this.props.params.eventId);

      if (eventDetails !== undefined) {
        let currentEvent = this.props.events[this.props.params.eventId];
        Object.keys(eventDetails).forEach((studentId) => {
          if (this.props.students[this.props.params.eventId].includes(studentId)) {
            let student = eventDetails[studentId];

            Object.keys(student).forEach((measurementId) => {
              let measurement = student[measurementId];

              currentEvent.event_roles.forEach((eventRole) => {
                eventRole.end_terms.forEach((endterm) => {
                  endterm.competences.forEach((comp) => {
                    comp.bundles.forEach((bundle) => {
                      bundle.measurements.forEach((meas) => {
                        let checkEx = this.state.courseExemptions.find(
                          (ex) => ex.end_term === endterm.end_term.uuid && ex.user === studentId && ex.course === currentEvent.course
                        );

                        if (!checkEx && this.props.students[this.props.params.eventId].includes(studentId)) {
                          if (meas.uuid == measurementId && measurement != 0 && !measurementId.includes("bundle") && !measurementId.includes("comp")) {
                            let newMeasurement = {
                              measurement: measurementId,
                              user: studentId,
                              score_type: parseInt(measurement)
                            };
                            sendMeasurements.push(newMeasurement);
                          }
                        }
                      });
                    });
                  });
                });
              });
            });
          }
        });

        this.setState({
          sendMeasurementsInfo: "Bezig met het verzenden van de toetsingen...",
          sendMeasurementsAlert: ""
        });

        let requests = [];

        // Update the students to let the system know they attended
        let updateStudent = {};
        Object.keys(eventDetails).forEach((studentId) => {
          if (this.props.students[this.props.params.eventId].includes(studentId)) {
            updateStudent = {
              attended: true
            };

            // Find the event role for this student:
            const studentEventRole = this.props.events[this.props.params.eventId].event_roles.find((role) => {
              // if the role contains this student we have found our role!
              return role.students.filter((s) => !s.cancelled).find((student) => student.uuid === studentId);
            });

            if (studentEventRole) {
              requests.push(
                axios
                  .patch("/v1/events/" + this.props.params.eventId + "/eventroles/" + studentEventRole.uuid + "/students/" + studentId + "/", updateStudent)
                  .catch(function (err) {
                    console.warn("API Error: Updating student after finishing an event did not succeed, student ID: " + studentId, err);
                  })
              );
            } else {
              console.warn(`Could not determine the role for student ${studentId}`);
            }
          }
        });

        // Update instructors that were present
        if (currentEvent) {
          currentEvent.event_roles.forEach((role) => {
            this.state.instructorsPresent.forEach((uuid) => {
              requests.push(
                axios
                  .patch(`/v1/events/${this.props.params.eventId}/eventroles/${role.uuid}/instructors/${uuid}/`, {
                    attended: true
                  })
                  .catch((err) => {
                    console.warn("API Error: Updating instructor after finishing an event did not succeed, instructor ID: " + uuid, err);
                  })
              );
            });
          });
        }

        axios
          .all(requests)
          .then((results) => {
            axios
              .post("/v1/events/" + this.props.params.eventId + "/results/", sendMeasurements)
              .then((response) => {
                if (response.data) {
                  this.setState({
                    sendMeasurementsInfo: "",
                    sendMeasurementsAlert: "",
                    dialogConfirmationVisible: true
                  });
                  this.handleDialogClose();
                }
              })
              .catch((err) => {
                if (err && err.response && err.response.data && err.response.data.detail) {
                  this.setState({
                    sendMeasurementsInfo: "",
                    sendMeasurementsAlert: <span>{err.response.data.detail}</span>
                  });
                } else {
                  this.setState({
                    sendMeasurementsInfo: "",
                    sendMeasurementsAlert: (
                      <span>
                        De resultaten zijn helaas niet goed verzonden.
                        <br />
                        Neem contact op met NIBHV op 010 - 289 28 88.
                        <br />
                        Klik op annuleren om terug te keren naar het toetsmoment.
                      </span>
                    )
                  });
                }
                console.warn("API Error: Sending results did not succeed", err);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.setState({
          sendMeasurementsAlert: "Er zijn nog geen toetsresultaten ingevuld"
        });
      }
    } else {
      this.setState({
        showAlertNoCheckbox: true
      });
    }
  };

  handleDialogConfirmationClose = () => {
    this.setState(
      {
        dialogConfirmationVisible: false
      },
      () => {
        this.props.fetchEvents();
        browserHistory.push("/");
      }
    );
  };

  componentDidUpdate() {
    if (this.props.events[this.props.params.eventId] && !this.props.events[this.props.params.eventId].loading_details) {
      this.props.fetchEventDetails(this.props.params.eventId);
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.props.initStudentsForEvent(this.props.params.eventId);
      this.checkStudentsPresent();
    }, 1000);
  }

  getEvents = async () => {
    try {
      const response = await axios.get(`/v1/events/${this.props.params.eventId}/exemptions/?pagination=false&fields=user,course,competence_profile,end_term`);

      this.setState({
        courseExemptions: response.data
      });
    } catch (error) {
      console.log(error);
    }
  };

  componentWillMount() {
    if (this.props.events === undefined || this.props.events.length === 0) {
      this.props.fetchEvents();
    }
    this.getEvents();
  }

  render() {
    const currentEvent = this.props.events[this.props.params.eventId];
    const instructors = [];
    const unfinishedStudents = [];
    const warningStudents = [];
    let unfinishedMeasurements = {};
    let unfinishedCompetences = {};

    if (this.props.events.length === 0 || currentEvent === undefined) {
      return (
        <div className="alert alert-info" key="uniquep">
          Ophalen van toetsmoment details...
        </div>
      );
    }

    if (currentEvent !== undefined && currentEvent.event_roles !== undefined) {
      currentEvent.event_roles.forEach((eventRole) => {
        eventRole.students
          .filter((s) => !s.cancelled)
          .forEach((student) => {
            if (student.will_attend) {
              let studentUnfinishedCompetences = new Set();
              // Check percentage
              let measurementsTotal = 0;
              let measurementsDone = 0;
              let tempObject = getDeep(this.props.measurements, this.props.params.eventId, student.uuid);
              // Get the measurements that are under the active student
              if (tempObject !== undefined && tempObject !== null) {
                Object.keys(tempObject).forEach((key) => {
                  // Check measurements with results
                  let checkUUID = key.toString();

                  if (!checkUUID.includes("bundle") && !checkUUID.includes("comp")) {
                    measurementsTotal++;

                    // Only mark a measurement as done if it has a result more than 0
                    if (tempObject[key] > 0) {
                      measurementsDone++;
                    } else {
                      // Find the related competence UUID for the unfinished measurement
                      let relatedCompetenceUUID = null;
                      for (const endTerm of eventRole.end_terms) {
                        for (const competence of endTerm.competences) {
                          for (const bundle of competence.bundles) {
                            for (const measurement of bundle.measurements) {
                              if (measurement.uuid === key) {
                                relatedCompetenceUUID = competence.competence;
                                break;
                              }
                            }
                            if (relatedCompetenceUUID) break;
                          }
                          if (relatedCompetenceUUID) break;
                        }
                        if (relatedCompetenceUUID) break;
                      }
                      studentUnfinishedCompetences.add(relatedCompetenceUUID);
                    }
                  }
                });
              }

              // Check for exemptions for this student
              eventRole.end_terms.forEach((endterm) => {
                let checkEx = this.state.courseExemptions.find(
                  (ex) => ex.end_term === endterm.end_term.uuid && ex.user === student.uuid && ex.course === currentEvent.course
                );
                if (checkEx) {
                  endterm.competences.forEach((comp) => {
                    comp.bundles.forEach((bundle) => {
                      measurementsTotal -= bundle.measurements.length;
                    });
                  });
                }
              });

              let percentage = Math.round((measurementsDone / measurementsTotal) * 100);

              if (measurementsTotal === 0) {
                percentage = 0;
              } else if (
                percentage < 100 &&
                this.props.students &&
                this.props.students[this.props.params.eventId] &&
                this.props.students[this.props.params.eventId].includes(student.uuid)
              ) {
                unfinishedStudents.push(student);
                unfinishedCompetences[student.uuid] = Array.from(studentUnfinishedCompetences);
              }
            }
          });
        eventRole.instructor_details.forEach((instructor) => {
          instructors.push({
            uuid: instructor.uuid,
            name: instructor.full_name
          });
        });
      });
    }

    let i = 0;

    Object.keys(unfinishedStudents).forEach((key) => {
      const student = unfinishedStudents[key];

      warningStudents.push(
        <div key={"warning" + student.uuid + i++}>
          - {student.first_name} {student.last_name_prefix} {student.last_name}
          {Object.keys(unfinishedCompetences).map((key) => {
            if (key === student.uuid) {
              return (
                <ul key={student.uuid}>
                  {unfinishedCompetences[key].map((comp) => {
                    return (
                      <li className="unfinished-competence" key={comp.uuid}>
                        {comp.name}
                      </li>
                    );
                  })}
                </ul>
              );
            }
          })}
        </div>
      );
    });

    return (
      <div>
        <Dialog
          title="Insturen van de resultaten"
          onClose={this.handleDialogClose}
          animation="fade"
          visible={this.props.dialogVisible}
          key="sendmeasurementsdialog"
          footer={[
            <button type="button" className="btn btn-secondary" key="close" onClick={this.handleDialogClose}>
              Annuleren
            </button>,
            <button type="button" className="btn btn-primary" key="save" onClick={this.handleSaveEvent} disabled={warningStudents.length > 0}>
              Opslaan en insturen
            </button>
          ]}
        >
          <p>
            <strong>Insturen van de resultaten (binnen 24 uur)</strong>
            <br />
            De ingevulde competentieresultaten van de cursisten moeten binnen 24 uur na het toetsmoment verstuurd worden naar NIBHV. Dit specifieke toetsmoment verdwijnt
            vervolgens automatisch uit deze tool.
          </p>

          {warningStudents.length > 0 && (
            <div className="alert alert-danger" key="unfinishedwarning">
              <p>De volgende deelnemers hebben nog niet alle resultaten onder hun competenties ingevuld staan:</p>
              {warningStudents}
              <br />
              Vul deze resultaten aan voordat ze ingestuurd worden. Als niet alle competenties resultaten hebben kan er niet ingestuurd worden.
            </div>
          )}

          <hr />

          <p>De volgende instructeurs zijn aanwezig geweest op dit toetsmoment:</p>
          <div className="custom-control custom-checkbox event-dialog-checkbox" key="main-instructor">
            <input className="custom-control-input" type="checkbox" ref="main-instructor" id="main-instructor" checked={true} disabled={true} />
            <label className="custom-control-label custom-control-description" htmlFor="main-instructor">
              {localStorage.userName || "U"} (hoofdinstructeur)
            </label>
          </div>

          {instructors
            .filter((i) => i.uuid !== localStorage.userUUID)
            .map((instructor) => {
              return (
                <div className="custom-control custom-checkbox event-dialog-checkbox" key={`instructor-${instructor.uuid}`}>
                  <input
                    className="custom-control-input"
                    type="checkbox"
                    ref={`instructor-${instructor.uuid}`}
                    id={`instructor-${instructor.uuid}`}
                    checked={this.state.instructorsPresent.includes(instructor.uuid)}
                    value={instructor.uuid}
                    onChange={this.handleInstructorPresentChange}
                  />
                  <label className="custom-control-label custom-control-description" htmlFor={`instructor-${instructor.uuid}`}>
                    {instructor.name}{" "}
                  </label>
                </div>
              );
            })}

          <hr />

          <div className="custom-control custom-checkbox event-dialog-checkbox" key="checkbox1">
            <input
              className="custom-control-input"
              type="checkbox"
              ref="checkbox1"
              id="checkbox1"
              checked={this.state.checkbox1}
              onChange={() => this.handleCheckbox("checkbox1")}
            />
            <label className="custom-control-label custom-control-description" htmlFor="checkbox1">
              Bovenstaande instructeurs hebben alle cursisten van dit toetsmoment beoordeeld op de competenties en toetsingen.
            </label>
          </div>
          {this.state.checkbox1 ? <div></div> : ""}
          {this.state.showAlertNoCheckbox && (
            <div className="alert alert-info">Vink het bovenstaande vakje aan voordat je de resultaten van het toetsmoment instuurt</div>
          )}

          {this.state.sendMeasurementsInfo && (
            <div className="alert alert-info" key="measurementinfo">
              {this.state.sendMeasurementsInfo}
            </div>
          )}
          {this.state.sendMeasurementsAlert && (
            <div className="alert alert-danger" key="measurementalert">
              {this.state.sendMeasurementsAlert}
            </div>
          )}
        </Dialog>

        <Dialog
          title="Insturen van de resultaten"
          onClose={this.handleDialogConfirmationClose}
          animation="fade"
          visible={this.state.dialogConfirmationVisible}
          key="sentmeasurementsdialog"
          footer={[
            <button type="button" className="btn btn-primary" key="save" onClick={this.handleDialogConfirmationClose}>
              Terug naar het overzicht
            </button>
          ]}
        >
          <p>
            De ingevulde competentieresultaten zijn succesvol verstuurd naar NIBHV en worden verwerkt. Dit specifieke toetsmoment verdwijnt automatisch uit deze tool. Je
            gaat nu terug naar het overzicht van de toetsmomenten.
          </p>
        </Dialog>
      </div>
    );
  }
}

export default SendResultsModal;



// WEBPACK FOOTER //
// ./components/SendResultsModal.js